/**
* 基础账户
*/

import domain from '@common/domain'
import clientNewView from '@common/client/src/newView'
import ajax from '@finance/ajax'

import { callbackHandler, getUserData } from '../utils'

// 部分交互需要在新窗口打开开户链接
// 此处增加一个配置，以满足页面交互需求
const openInWebview = (currentView, url) => {
  if (currentView) {
    window.location.href = url
  } else {
    clientNewView(url)
  }
}
// 页面跳转
const openAccountHandler = (options) => {
  const url = `${domain.res}/public-vue/account/index.html#/open?type=acc&origin=${options.origin}&forward=${encodeURIComponent(options.forwardUrl)}`
  openInWebview(options.currentView, url)
}
// 请求账户接口
const requestUserDataApi = () => {
  return ajax.request({
    url: `${domain.api}/accountws/ws/account/v3/getUserData`
  })
}
// 成功回调
async function successCallback(options) {
  try {
    const userData = await getUserData(options.isNeedUserData)
    callbackHandler(options.success, userData)
  } catch (error) {
    console.log('Get UserData Error:', error)
  }
}
// 执行
async function init(options) {
  try {
    const result = await requestUserDataApi()
    if (result.succeed) {
      if (result.data.bizOwners && result.data.bizOwners.indexOf('ACC') !== -1) {
        successCallback(options)
      } else {
        openAccountHandler(options)
      }
    } else {
      throw new Error(result.msg)
    }
  } catch (error) {
    console.error('Account Error: getUserData', error)
    callbackHandler(options.error, { msg: '网络请求失败，请重试' })
  }
}

export const accountAcc = (options) => {
  init(options)
}

export default {
  accountAcc,
}
